import React from 'react';
import { useDispatch } from 'react-redux';
import { CartApiService } from '../../../service/cartApiService';
import { fetchCartItems } from '../../../../redux/slices/cartSlice';
import { minusIcon, plusIcon } from '../../../assets/icons';

export const CartProductQuantity = ({ count, product, setCount, variant = null }) => {
  const dispatch = useDispatch();

  const handleQuantity = async type => {
    try {
      let newCount = count;
      if (type === 'plus') {
        newCount = count + 1;
        setCount(newCount);
      } else if (type === 'minus') {
        newCount = count - 1;
        setCount(newCount);
      }

      // Build payload as per new schema
      const payload = {
        offerId: product.sku || product._id,
        variants: variant ? [{ skuId: variant.skuId, quantity: newCount }] : [],
      };

      const response = await CartApiService.AddUpdateCart(JSON.stringify(payload));
      if (response?.status) {
        dispatch(fetchCartItems());
      }
    } catch (error) {
      console.log('Error from CartProductQuantity:', error);
    }

    // CartApiService.AddUpdateCart(JSON.stringify(payload))
    //   .then(res => {
    //     if (res.status) {
    //       dispatch(fetchCartItems());
    //     }
    //   })
    //   .catch(error => {
    //     console.log('error', error);
    //   });
  };

  return (
    <div className="cart_item_quantity">
      <p onClick={() => handleQuantity('minus')}>{minusIcon}</p>
      <p>Qty : {count}</p>
      <p onClick={() => handleQuantity('plus')}>{plusIcon}</p>
    </div>
  );
};
